/**
 * Created by eliranm on 05/10/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var Button = require('ui/button/Button');

    var template = require('content-templates/content-import-errors/contentImportErrorsLayout.tmpl');
    var Config = require('content-config/contentImportErrorsConfig.json');
    var Paging = require('ui/paging/Paging');

    var ContentImportErrorsLayout = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportErrorsLayout = Marionette.Layout.extend({
            template: template,
            className: 'content-import-errors',
            regions: {
                errorsTableRegion: '.errors-table'
            },
            ui: {
                closeButton: '.button-close',
                pagingContainer: '.paging-container'
            },
            uiComponents: {
                closeButton: {
                    type: Button,
                    options: {
                        el: 'view.ui.closeButton',
                        permutation: Button.PERMUTATION.BTN
                    },
                    events: {
                        'click': '_triggerClosePage'
                    }
                },
                paging: {
                    type: Paging,
                    options: {
                        el: 'view.ui.pagingContainer',
                        blockWrongPageNumber: true
                    },
                    events: {
                        'change:page': '_onPageChange'
                    }
                }

            },


            // overridden

            initialize: function (options) {
                this.vent = options.vent;
                this._bindEvents();
            },


            // public

            setPagingInfo: function (info) {
                this.uiComponents.paging.setInfo(info.currentPageNumber, info.totalPages);
            },


            // private

            _bindEvents: function () {
                this.listenTo(this, Config.events.closePage, this._triggerClosePage);
            },

            _triggerClosePage: function () {
                this.vent.trigger(Config.events.closePageDelegate);
            },

            _onPageChange: function (comp, ev, data) {
                this.vent.trigger(Config.events.errorsTablePageChange, data);
            }

        });
    });

    return ContentImportErrorsLayout;
});
